import { ListColumn, ListColumnAlignment } from '@/interfaces'
import { computed } from 'vue'

const folderCols = computed<ListColumn[]>(() => {
  return [
    {
      name: 'name',
      title: 'content-folder-name',
      width: 25,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 1,
      priority: 1,
      expand: true
    },
    {
      name: 'number_of_videos',
      title: 'content-number-of-videos',
      width: 45,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 2,
      priority: 2
    },
    {
      name: 'create_date',
      title: 'content-created-at',
      width: 25,
      alignment: ListColumnAlignment.Center,
      sortable: true,
      position: 3,
      priority: 3
    },
    {
      name: 'actions',
      title: '',
      width: 5,
      alignment: ListColumnAlignment.Center,
      position: 4,
      priority: 0,
      minWidthInPx: '100px'
    }
  ]
})

export default folderCols
